import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center container content mt--30"
}
const _hoisted_2 = {
  key: 1,
  class: "container content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "underline main-color" }, "Назад", -1)
const _hoisted_4 = { class: "items-in-line flex-start flex-wrap mt--25 mb--30" }
const _hoisted_5 = {
  key: 0,
  class: "items-in-line gap--14"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "second-color" }, "/", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "second-color" }
const _hoisted_10 = {
  id: "editableData",
  class: "mt--20"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "mb--20"
}
const _hoisted_13 = { key: 2 }

import { computed, inject, onMounted, ref, Ref, toRaw } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ErrorsType, ParamsDataType } from '@/types';
import {
  errorHandle,
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import {
  prepareValueByType,
  ValueType,
  ValueTypeFromBack,
} from '@/utils/Common/DeveloperAdmin';
import UpdateFormFirst from '@/components/UpdateDeveloperComponents/UpdateForm/UpdateFormFirst.vue';
import { useRoute, useRouter } from 'vue-router';
import { updateCategoryDataApi } from '@/api/developer';
import { useDevelopersStore } from '@/store/modules/developers';
import {
  CategoryDataForUpdateApiType,
  ParamsValuesType,
  UpdateTypes,
} from '@/api/developer/types';
import { UpdateCategories, UpdateForm, UpdateParamsGroups } from '@/components';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';
import { ParamDataForSendType } from '@/types/UpdateDeveloperTypes';
import { useAppStore } from '@/store/modules/app';

type RulesType = { [key: string]: { [key: string]: ValidationRuleWithoutParams } };

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateMyCard',
  setup(__props) {

const isLoading = ref(false);
const isSaveLoading = ref(false);
const router = useRouter();
const editableData: Ref<CategoryDataForUpdateApiType | undefined> = ref(undefined);
const updatedEditableData: Ref<CategoryDataForUpdateApiType | undefined> = ref(undefined);

const paramsData: Ref<ParamsDataType> = ref({});

const backLink = computed(() => {
  let paramId;

  if (type.value === 'updateResidentialComplex') {
    paramId = 'MyResidentialComplex';
  } else if (type.value === 'updateDeveloper') {
    paramId = 'myDeveloper';
  } else {
    paramId = 'myAnnouncements';
  }

  return { name: 'profile', params: { id: paramId } };
});

const nextStepCategories = computed(() => {
  if (editableData.value) {
    return editableData.value.param_values
      .filter(el => el.type === 22)
      .filter(el => {
        return (
          el.group_id === 0 ||
          !editableData.value?.param_groups.map(group => group.id).includes(el.group_id)
        );
      });
  } else {
    return [];
  }
});
const withoutGroupParams = computed(() => {
  if (editableData.value && editableData.value.param_groups.filter(el => el.id === 0)) {
    return editableData.value.param_values.filter(
      el => el.group_id === 0 && el.type !== 22,
    );
  } else {
    return [];
  }
});

const rules = computed((): RulesType => {
  let rules: RulesType = {};

  editableData.value?.param_values
    .filter(el => el.type !== 22)
    .forEach(param => {
      let validators = {};

      if (param.required) {
        validators = { required };
      }
      rules[param.id] = { ...validators };
    });

  rules['value'] = { required };
  rules['public'] = {};
  rules['is_missed'] = {};

  return rules;
});

const v$ = useVuelidate<ParamsDataType>(rules, paramsData, {
  $autoDirty: true,
  $stopPropagation: true,
});

const errors: Ref<ErrorsType> = ref({});

const type = computed((): UpdateTypes => {
  return useRoute().name as UpdateTypes;
});
const validationErrorsHandlerByKey = (key: string | number) => {
  let error: string | undefined = errorsHandlerByKey(String(key), rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(paramsData.value, rules, v$);
};
const prepareNumberValue = (value: string | null): string | null => {
  return value ? value.replace(/[^.\d]+/g, '').replace(/^([^.]*\.)|\./g, '$1') : null;
};

const prepareDataForSend = (param: ValueType): ParamDataForSendType => {
  if ((param.type === 2 || param.type === 5) && param.value) {
    return String(param.value).replace(/\s/g, '');
  }
  if (param.type === 4) {
    if (param.value && +param.value) {
      return [param.value];
    } else {
      return JSON.parse(JSON.stringify([]));
    }
  }
  if (param.type === 8 && param.value) {
    return prepareNumberValue(param.value);
  }
  if ((param.type === 12 || param.type === 20) && param.value) {
    return param.value.split(/\s/, 2)[0];
  }
  if (param.type === 19 && param.value) {
    return `${param.value}-01-01`;
  }

  if (param.type === 24 || param.type === 25 || param.type === 28) {
    return {
      min: prepareNumberValue(param.value.min),
      max: prepareNumberValue(param.value.max),
    };
  }

  return param.value === undefined ? null : param.value;
};

const updateNewEditableData = (id: number, value) => {
  updatedEditableData.value.param_values = updatedEditableData.value.param_values.map(
    el => {
      if (el.id === id) {
        return { ...el, value: value };
      }

      return el;
    },
  );
};

const constructorDataForSend = (): FormData => {
  let sendData = new FormData();

  updatedEditableData.value = structuredClone(editableData.value);

  sendData.append('id', String(editableData.value?.id));
  Object.entries(paramsData.value).forEach(param => {
    if (param[1].type === 'main') {
      const oldValue = editableData.value
        ? editableData.value[param[0] as 'value' | 'public' | 'is_missed']
        : null;

      if (param[1].value !== oldValue) {
        sendData.append(param[0], param[1].value as string | Blob);
        updatedEditableData.value[param[0]] = param[1].value;
      }
    } else {
      const oldParam = editableData.value?.param_values.find(el => el.id === +param[0]);

      if (oldParam) {
        const oldParamValue = JSON.stringify(toRaw(oldParam?.value));
        const newParamValue = prepareDataForSend(param[1]);

        if (
          oldParamValue !== JSON.stringify(newParamValue) ||
          param[1].type === 10 ||
          param[1].type === 11 ||
          param[1].type === 15 ||
          param[1].type === 26
        ) {
          switch (param[1].type) {
            case 3:
              sendData.append(`parameters[${param[0]}]`, param[1].value ? '1' : '0');
              updateNewEditableData(+param[0], param[1].value ? '1' : '0');
              break;
            case 4:
              sendData.append(`parameters[${param[0]}]`, String(newParamValue));
              updateNewEditableData(+param[0], newParamValue);
              break;
            case 14:
              if (newParamValue) {
                (newParamValue as number[]).forEach(el => {
                  sendData.append(`parameters[${param[0]}][]`, String(el));
                });
                updateNewEditableData(+param[0], newParamValue);
              }
              break;
            case 15:
            case 10:
              if (param[1].value.newValue !== null) {
                sendData.append(
                  `parameters[${param[0]}]`,
                  param[1].value.newValue[0] as string | Blob,
                );
                updateNewEditableData(+param[0], param[1].value.newValue[0]);
              }
              break;

            case 11:
            case 26:
              if (param[1].value.newValue !== null) {
                Object.values(param[1].value.newValue).forEach(val => {
                  if (val !== null) {
                    sendData.append(`parameters[${param[0]}][]`, val);
                  }
                });
                updateNewEditableData(+param[0], param[1].value.newValue);
              }
              break;
            case 24:
            case 25:
            case 28:
              sendData.append(
                `parameters[${param[0]}][min]`,
                String(prepareNumberValue(param[1].value.min)),
              );
              sendData.append(
                `parameters[${param[0]}][max]`,
                String(prepareNumberValue(param[1].value.max)),
              );
              updateNewEditableData(+param[0], {
                min: param[1].value.min,
                max: param[1].value.max,
              });
              break;
            case 19:
              sendData.append(`parameters[${param[0]}]`, String(param[1].value));
              updateNewEditableData(+param[0], param[1].value);
              break;
            default:
              sendData.append(`parameters[${param[0]}]`, String(newParamValue));
              updateNewEditableData(+param[0], newParamValue);
              break;
          }
        }
      }
    }
  });

  return sendData;
};

const savedDataModal = ref({
  show: false,
  isError: false,
  message: '',
});

const closeSavedDataModal = () => {
  savedDataModal.value = {
    show: false,
    isError: false,
    message: '',
  };
};
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }
  if (editableData.value) {
    const sendData = constructorDataForSend();

    isSaveLoading.value = true;
    try {
      const res = await updateCategoryDataApi(type.value, sendData);

      if (res) {
        savedDataModal.value = {
          show: true,
          isError: false,
          message: 'Данные успешно изменены',
        };
        editableData.value = updatedEditableData.value;
        errors.value = {};
      }
    } catch (error) {
      errors.value = validationErrorsByRequest(error, 'parameters');
      savedDataModal.value = {
        show: true,
        isError: true,
        message: Object.keys(errors.value).length
          ? 'Данные заполнены некорректно'
          : 'Произошла ошибка',
      };
    } finally {
      isSaveLoading.value = false;
    }
  }
};

const updateCategory = async (categoryId: number) => {
  isLoading.value = true;

  try {
    const res = await useDevelopersStore().getCategoryDataForUpdate(
      type.value,
      categoryId,
    );

    if (res) {
      editableData.value = res;
      Object.keys(paramsData.value).forEach(key => delete paramsData.value[key]);
      paramsData.value['value'] = { type: 'main', value: res.value };
      paramsData.value['public'] = { type: 'main', value: res.public };
      if (res.may_be_missed) {
        paramsData.value['is_missed'] = { type: 'main', value: res.is_missed };
      }

      res.param_values.forEach((param: ParamsValuesType) => {
        if (param.type !== 22) {
          paramsData.value[param.id] = prepareValueByType({
            type: param.type,
            value: param.value,
          } as ValueTypeFromBack);
        }
      });
    }
  } catch (error) {
    errorHandle(error);
    await router.push({ name: 'main' });
  } finally {
    isLoading.value = false;
  }
};

const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;
const changeCategory = (categoryId: number) => {
  updateCategory(categoryId);
  router.push({
    query: {
      id: categoryId,
    },
  });
  const myEl = document.getElementById(`editableData`);

  if (myEl) {
    smoothScroll({
      scrollTo: myEl,
      offset: -200,
      updateHistory: false,
    });
  }
};
const createCategory = (
  newCategory: { id: number; title: string },
  categoryId: number,
) => {
  if (editableData.value?.param_values) {
    editableData.value.param_values = editableData.value?.param_values.map(param => {
      if (param.type === 22 && param.value) {
        if (param.id === categoryId) {
          return { ...param, value: [...param.value, newCategory] };
        }
      }

      return param;
    });
  }
};

const deleteCategory = (paramId: number, categoryId: number) => {
  if (editableData.value?.param_values) {
    editableData.value.param_values = editableData.value?.param_values.map(param => {
      if (param.type === 22 && param.value) {
        if (param.id === categoryId) {
          return { ...param, value: param.value.filter(el => el.id !== paramId) };
        }
      }

      return param;
    });
  }
};

onMounted(async () => {
  const categoryId = useRoute().query.id;

  if (categoryId) {
    await updateCategory(+categoryId);
  } else {
    useAppStore().togglePageNotFound(true);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_info_modal = _resolveComponent("base-info-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_base_spinner, {
            size: 50,
            color: "#009D3E"
          })
        ]))
      : (editableData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: backLink.value,
              class: "items-in-line flex-start mt--25 gap--5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  color: "#009D3E",
                  name: "arrow_back"
                }),
                _hoisted_3
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(editableData.value.breadcrumbs), (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item[0],
                  class: "items-in-line gap--5"
                }, [
                  (i !== Object.values(editableData.value.breadcrumbs).length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("h3", {
                          class: "pointer main-color",
                          onClick: ($event: any) => (changeCategory(+item[0]))
                        }, _toDisplayString(item[1]), 9, _hoisted_6),
                        _hoisted_7
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("h3", _hoisted_9, _toDisplayString(item[1]), 1)
                      ]))
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_10, [
              (editableData.value?.param_groups)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (withoutGroupParams.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createVNode(_unref(UpdateForm), {
                            paramsData: paramsData.value,
                            "onUpdate:paramsData": _cache[0] || (_cache[0] = ($event: any) => ((paramsData).value = $event)),
                            v$: _unref(v$),
                            "onUpdate:v$": _cache[1] || (_cache[1] = ($event: any) => (_isRef(v$) ? (v$).value = $event : null)),
                            categoryId: editableData.value?.category_id,
                            errors: errors.value,
                            params: withoutGroupParams.value,
                            parentId: editableData.value?.id,
                            rules: rules.value,
                            onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value[$event])),
                            onValidationErrorsHandlerByKey: _cache[3] || (_cache[3] = ($event: any) => (validationErrorsHandlerByKey($event))),
                            onInputTouch: _unref(v$)['value']?.$touch,
                            onChangeCategory: _cache[4] || (_cache[4] = ($event: any) => (changeCategory($event)))
                          }, null, 8, ["paramsData", "v$", "categoryId", "errors", "params", "parentId", "rules", "onInputTouch"])
                        ]))
                      : _createCommentVNode("", true),
                    (editableData.value?.param_groups.filter(el => el.id !== 0).length)
                      ? (_openBlock(), _createBlock(_unref(UpdateParamsGroups), {
                          key: 1,
                          paramsData: paramsData.value,
                          "onUpdate:paramsData": _cache[5] || (_cache[5] = ($event: any) => ((paramsData).value = $event)),
                          v$: _unref(v$),
                          "onUpdate:v$": _cache[6] || (_cache[6] = ($event: any) => (_isRef(v$) ? (v$).value = $event : null)),
                          errors: errors.value,
                          paramValues: editableData.value.param_values,
                          "params-groups": editableData.value.param_groups.filter(el => el.id !== 0),
                          parentId: editableData.value?.id,
                          rules: rules.value,
                          class: "mb--30",
                          onFocus: _cache[7] || (_cache[7] = ($event: any) => (delete errors.value[$event])),
                          onValidationErrorsHandlerByKey: _cache[8] || (_cache[8] = ($event: any) => (validationErrorsHandlerByKey($event))),
                          onInputTouch: _unref(v$)['value']?.$touch,
                          onChangeCategory: _cache[9] || (_cache[9] = ($event: any) => (changeCategory($event))),
                          onCreateCategory: _cache[10] || (_cache[10] = ($event: any) => (createCategory(...$event))),
                          onDeleteCategory: _cache[11] || (_cache[11] = ($event: any) => (deleteCategory(...$event)))
                        }, null, 8, ["paramsData", "v$", "errors", "paramValues", "params-groups", "parentId", "rules", "onInputTouch"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(UpdateFormFirst, {
                paramsData: paramsData.value,
                "onUpdate:paramsData": _cache[12] || (_cache[12] = ($event: any) => ((paramsData).value = $event)),
                v$: _unref(v$),
                "onUpdate:v$": _cache[13] || (_cache[13] = ($event: any) => (_isRef(v$) ? (v$).value = $event : null)),
                errors: errors.value,
                isSaveLoading: isSaveLoading.value,
                onFocus: _cache[14] || (_cache[14] = ($event: any) => (delete errors.value[$event])),
                onSave: formSubmit,
                onValidationErrorsHandlerByKey: _cache[15] || (_cache[15] = ($event: any) => (validationErrorsHandlerByKey($event)))
              }, null, 8, ["paramsData", "v$", "errors", "isSaveLoading"]),
              (nextStepCategories.value.length)
                ? (_openBlock(), _createBlock(_component_base_divider, {
                    key: 1,
                    class: "mt--30 mb--30"
                  }))
                : _createCommentVNode("", true),
              (nextStepCategories.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nextStepCategories.value, (category) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        _createVNode(_unref(UpdateCategories), {
                          categoryId: category.options['list-category'],
                          "editable-category": category.value,
                          parentId: editableData.value?.id,
                          title: category.title,
                          onChangeCategory: _cache[16] || (_cache[16] = ($event: any) => (changeCategory($event))),
                          onCreateCategory: ($event: any) => (createCategory($event, category.id)),
                          onDeleteCategory: ($event: any) => (deleteCategory($event, category.id))
                        }, null, 8, ["categoryId", "editable-category", "parentId", "title", "onCreateCategory", "onDeleteCategory"])
                      ]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
    (savedDataModal.value.show)
      ? (_openBlock(), _createBlock(_component_base_info_modal, {
          key: 2,
          "is-error": savedDataModal.value.isError,
          "show-info-modal": savedDataModal.value.show,
          onClose: closeSavedDataModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(savedDataModal.value.message), 1)
          ]),
          _: 1
        }, 8, ["is-error", "show-info-modal"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})